import { render, staticRenderFns } from "./TabsModuleSelector.vue?vue&type=template&id=49718623&scoped=true&"
import script from "./TabsModuleSelector.vue?vue&type=script&lang=js&"
export * from "./TabsModuleSelector.vue?vue&type=script&lang=js&"
import style0 from "./TabsModuleSelector.vue?vue&type=style&index=0&id=49718623&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49718623",
  null
  
)

export default component.exports